// Tour Planner — top-level plan-list route.
// -----------------------------------------------------------------
// Per docs/architecture/m4-tour-planner-plan.md § 3 M4.1 + dispatch
// docs/architecture/dispatches/m4-1-plan-list-editor-shell.md § 1
// + § 6.8.
//
// Supersedes the M3.4 placeholder body. Renders:
//   - Page title.
//   - <CreatePlanForm /> (New Plan + Import-from-production tabs).
//   - <PlanList /> (Mantine table; live listener via
//     useFirestoreCollection<TourPlan>('tours_plans')).
//
// Feature-flag gate preserved from M3.4: when
// VITE_FF_TOUR_PLANNER !== 'on', the route mounts and immediately
// <Navigate to='/hello' replace />s. .env.staging gets flipped to
// `on` at lead-direct M4.1-P2; .env.production stays off until
// M4.6.
//
// Per dispatch § 3.6: AppShell sidebar entry already exists from
// M3.4; no AppShell modifications in M4.1.

import { Stack, Title } from '@mantine/core';
import { Navigate, createFileRoute } from '@tanstack/react-router';

import { CreatePlanForm } from '@/components/tour-planner/CreatePlanForm';
import { PlanList } from '@/components/tour-planner/PlanList';
import { isFeatureEnabled } from '@/lib/featureFlags';

const TourPlannerRoute = () => {
  if (!isFeatureEnabled('TOUR_PLANNER')) {
    return <Navigate to='/hello' replace />;
  }
  return (
    <Stack>
      <Title order={2}>Tour Planner</Title>
      <CreatePlanForm />
      <PlanList />
    </Stack>
  );
};

export const Route = createFileRoute('/_authenticated/tour-planner')({
  component: TourPlannerRoute,
});
